import { INTERACTIVE_LINKS } from 'utils/constants';
import AITransformationMenu from '../AITransformationMenu';
import ServiceMenu from '../ServiceMenu';
import WorksMenu from '../WorksMenu';
import CompanyMenu from '../CompanyMenu';

export const DROPDOWN_CONTENT = {
  [INTERACTIVE_LINKS.company.slug]: CompanyMenu,
  [INTERACTIVE_LINKS.services.slug]: ServiceMenu,
  [INTERACTIVE_LINKS.aiTransformation.slug]: AITransformationMenu,
  [INTERACTIVE_LINKS.works.slug]: WorksMenu,
};
